(function () {
  "use strict";

  function whenSwiperReady(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== "undefined") {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function norm(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function escAttr(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function isFlatColorGallery(galleryData) {
    if (!galleryData || typeof galleryData !== "object") return false;
    var keys = Object.keys(galleryData);
    if (!keys.length) return false;
    return Array.isArray(galleryData[keys[0]]);
  }

  function resetGalleryToFirstSlide(swiper) {
    if (!swiper || swiper.destroyed) return;
    if (swiper.params.loop && typeof swiper.slideToLoop === "function") {
      swiper.slideToLoop(0, 0);
    } else {
      swiper.slideTo(0, 0);
    }
    if (typeof swiper.update === "function") swiper.update();
  }

  function resolveGalleryImages(galleryData, color) {
    if (!galleryData) return [];

    if (isFlatColorGallery(galleryData)) {
      if (!color) {
        var fallbackKeys = Object.keys(galleryData);
        return fallbackKeys.length ? galleryData[fallbackKeys[0]] : [];
      }
      if (galleryData[color]) return galleryData[color];
      var c = norm(color);
      var colorKeys = Object.keys(galleryData);
      for (var i = 0; i < colorKeys.length; i++) {
        if (norm(colorKeys[i]) === c) return galleryData[colorKeys[i]];
      }
      for (var j = 0; j < colorKeys.length; j++) {
        var k = norm(colorKeys[j]);
        if (k.indexOf(c) !== -1 || c.indexOf(k) !== -1) return galleryData[colorKeys[j]];
      }
      return colorKeys.length ? galleryData[colorKeys[0]] : [];
    }

    return [];
  }

  function initGallery(section, done) {
    if (!section || section.dataset.fridoPdpGalleryInit === "true") {
      if (done) done();
      return;
    }

    var mediaEl = section.querySelector("[data-frido-pdp-gallery-media]");
    if (!mediaEl) {
      if (done) done();
      return;
    }

    var slideCount = mediaEl.querySelectorAll(".swiper-slide").length;
    if (slideCount < 1) {
      if (done) done();
      return;
    }

    whenSwiperReady(function () {
      if (section.dataset.fridoPdpGalleryInit === "true") {
        if (done) done();
        return;
      }

      var pagination = section.querySelector("[data-frido-pdp-gallery-pagination]");
      var prevEl = section.querySelector("[data-frido-pdp-gallery-prev]");
      var nextEl = section.querySelector("[data-frido-pdp-gallery-next]");
      var showNav = section.getAttribute("data-show-nav") === "true";
      var showPagination = section.getAttribute("data-show-pagination") !== "false";

      var options = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slideCount > 1,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        pagination:
          showPagination && pagination
            ? { el: pagination, clickable: true }
            : false,
        navigation:
          showNav && prevEl && nextEl
            ? { prevEl: prevEl, nextEl: nextEl }
            : false,
      };

      section._fridoPdpGallerySwiper = new Swiper(mediaEl, options);
      resetGalleryToFirstSlide(section._fridoPdpGallerySwiper);
      section.dataset.fridoPdpGalleryInit = "true";
      if (done) done(section._fridoPdpGallerySwiper);
    });
  }

  function destroyGallery(section) {
    if (!section || !section._fridoPdpGallerySwiper) return;
    var swiper = section._fridoPdpGallerySwiper;
    if (!swiper.destroyed) {
      if (swiper.params.loop && typeof swiper.loopDestroy === "function") {
        swiper.loopDestroy();
      }
      swiper.destroy(false, false);
    }
    delete section._fridoPdpGallerySwiper;
    delete section.dataset.fridoPdpGalleryInit;
  }

  function initVariantGallery(section) {
    if (!section || section.dataset.fridoPdpVariantGalleryInit === "true") return;

    var url = section.getAttribute("data-frido-pdp-gallery-url");
    var track = section.querySelector("[data-frido-pdp-gallery-track]");
    var mediaEl = section.querySelector("[data-frido-pdp-gallery-media]");
    var mediaShell = section.querySelector(".frido-pdp-gallery__media-shell");
    if (!track || !mediaEl) return;

    var productTitle =
      section.getAttribute("data-frido-pdp-gallery-product-title") || "Frido Travel Neck Pillow";
    var galleryData = null;
    var pendingColor = null;
    var galleryApplyId = 0;

    function setGalleryLoading(isLoading) {
      if (!mediaShell) return;
      mediaShell.classList.toggle("is-gallery-loading", !!isLoading);
      mediaShell.setAttribute("aria-busy", isLoading ? "true" : "false");
    }

    function renderLoadingSlide() {
      track.innerHTML =
        '<div class="swiper-slide frido-pdp-gallery__slide">' +
        '<div class="frido-pdp-gallery__placeholder frido-pdp-gallery__placeholder--loading">Loading gallery…</div>' +
        "</div>";
    }

    function renderSlides(urls, colorName) {
      if (!urls.length) {
        track.innerHTML =
          '<div class="swiper-slide frido-pdp-gallery__slide">' +
          '<div class="frido-pdp-gallery__placeholder">Gallery images unavailable for this color</div>' +
          "</div>";
        return;
      }

      var alt = (colorName ? colorName + " — " : "") + productTitle;
      var slides = urls.map(function (src, index) {
        return (
          '<div class="swiper-slide frido-pdp-gallery__slide">' +
          '<img src="' +
          escAttr(src) +
          '" alt="' +
          escAttr(alt) +
          '" width="1200" height="1200" loading="' +
          (index === 0 ? "eager" : "lazy") +
          '"' +
          (index === 0 ? ' fetchpriority="high"' : "") +
          ' decoding="async" sizes="(max-width: 767px) 100vw, 560px">' +
          "</div>"
        );
      });

      track.innerHTML = slides.join("");
    }

    function preloadFirstImage(urls) {
      if (!urls.length) return Promise.resolve();
      return new Promise(function (resolve) {
        var img = new Image();
        img.decoding = "async";
        img.onload = img.onerror = function () {
          resolve();
        };
        img.src = urls[0];
      });
    }

    function applyInitialGallery() {
      if (!galleryData) return;
      var color = pendingColor || readDefaultColor();
      if (color) {
        applyGallery(color);
        return;
      }
      var keys = Object.keys(galleryData);
      if (keys.length) applyGallery(keys[0]);
      else setGalleryLoading(false);
    }

    function applyGallery(colorName) {
      if (!galleryData) return;

      var urls = resolveGalleryImages(galleryData, colorName);
      var applyToken = (galleryApplyId += 1);

      setGalleryLoading(true);
      destroyGallery(section);

      function mountSlides() {
        if (applyToken !== galleryApplyId) return;
        renderSlides(urls, colorName);
        initGallery(section, function (swiper) {
          if (applyToken !== galleryApplyId) return;
          resetGalleryToFirstSlide(swiper || section._fridoPdpGallerySwiper);
          window.requestAnimationFrame(function () {
            if (applyToken !== galleryApplyId) return;
            resetGalleryToFirstSlide(section._fridoPdpGallerySwiper);
            setGalleryLoading(false);
          });
        });
      }

      if (!urls.length) {
        mountSlides();
        return;
      }

      preloadFirstImage(urls).then(mountSlides);
    }

    function loadGalleryData() {
      var inline = section.querySelector("[data-frido-pdp-gallery-data]");
      if (inline) {
        try {
          return Promise.resolve(JSON.parse(inline.textContent));
        } catch (e) {
          /* fall through to fetch */
        }
      }

      if (!url) return Promise.reject(new Error("missing gallery url"));

      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error("gallery fetch failed");
        return res.json();
      });
    }

    function readDefaultColor() {
      var picker = document.querySelector("[data-frido-pdp-product-picker]");
      if (picker) {
        var swatch = picker.querySelector("[data-frido-picker-swatch].is-selected");
        if (swatch) return swatch.getAttribute("data-color-value");
      }

      var fiveToeSwatch =
        document.querySelector("[data-ft-colors-scroll] .ft-color-btn.active") ||
        document.querySelector(".ft-color-btn.active");
      if (fiveToeSwatch) {
        return (
          fiveToeSwatch.getAttribute("data-gallery-color") ||
          fiveToeSwatch.getAttribute("data-color")
        );
      }

      return null;
    }

    function onColorChange(colorValue) {
      if (!colorValue) return;
      pendingColor = colorValue;
      if (galleryData) applyGallery(pendingColor);
    }

    document.addEventListener("frido:pdp-product-change", function (event) {
      onColorChange((event.detail || {}).colorValue);
    });

    document.addEventListener("frido:pdp-gallery-color-change", function (event) {
      onColorChange((event.detail || {}).colorValue);
    });

    section.dataset.fridoPdpVariantGalleryInit = "true";
    renderLoadingSlide();
    setGalleryLoading(true);

    loadGalleryData()
      .then(function (data) {
        galleryData = data;
        applyInitialGallery();
        window.setTimeout(applyInitialGallery, 400);
      })
      .catch(function () {
        track.innerHTML =
          '<div class="swiper-slide frido-pdp-gallery__slide">' +
          '<div class="frido-pdp-gallery__placeholder">Could not load gallery</div>' +
          "</div>";
        initGallery(section, function () {
          setGalleryLoading(false);
        });
      });
  }

  function bootSection(section) {
    if (section.hasAttribute("data-frido-pdp-variant-gallery")) {
      initVariantGallery(section);
      return;
    }
    initGallery(section);
  }

  function boot() {
    document.querySelectorAll("[data-frido-pdp-gallery]").forEach(bootSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-frido-pdp-gallery]");
    if (section) bootSection(section);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector("[data-frido-pdp-gallery]");
    if (section) destroyGallery(section);
  });
})();
